import { useAuthAuthenticated } from "./auth-fe2.esm.js";
import React, { useCallback, useState } from "react";
import { Col, Form, Link, Text, TextInput } from "@opendoor/bricks-next";
//#region src/ReauthForm/ReauthForm.tsx
/** UI for the user to reauthenticate. Commonly used before allowing the user to view sensitive data. */
var ReauthForm = ({ onSuccess, title, resetPasswordHref = "/reset-password", analyticsPrefix = "auth-fe-reauth", renderAdditionalAuth }) => {
	const { user, verifyLogin } = useAuthAuthenticated();
	const [password, setPassword] = useState("");
	const [loading, setLoading] = useState(false);
	const [loginFailed, setLoginFailed] = useState(false);
	const reportLoginFailure = useCallback(() => {
		setLoginFailed(true);
	}, []);
	const verifyLoginCallback = useCallback(async (credentials) => {
		setLoading(true);
		setLoginFailed(false);
		try {
			if ((await verifyLogin(credentials)).success) onSuccess();
			else reportLoginFailure();
		} catch {
			reportLoginFailure();
		} finally {
			setLoading(false);
		}
	}, [
		onSuccess,
		reportLoginFailure,
		verifyLogin
	]);
	return /* @__PURE__ */ React.createElement(Col, { gap: "$12x" }, title ? /* @__PURE__ */ React.createElement(Text, {
		tag: "h2",
		typography: "$headerMedium"
	}, title) : null, /* @__PURE__ */ React.createElement(Text, {
		tag: "p",
		typography: "$bodyMedium"
	}, "Signing in as", " ", /* @__PURE__ */ React.createElement(Link, {
		variant: "secondary",
		size: "medium",
		analyticsName: `${analyticsPrefix}-user-email`,
		href: `mailto:${user.email}`,
		onPress: () => {}
	}, user.email)), /* @__PURE__ */ React.createElement(Form, {
		formId: `${analyticsPrefix}-form`,
		onSubmit: (event) => {
			event.preventDefault();
			verifyLoginCallback({
				email: user.email,
				password
			});
		}
	}, /* @__PURE__ */ React.createElement(Form.Form, null, /* @__PURE__ */ React.createElement(Col, { gap: "$12x" }, /* @__PURE__ */ React.createElement(TextInput, {
		analyticsName: `${analyticsPrefix}-password`,
		id: "reauth-password",
		size: "medium",
		onChangeText: (value) => setPassword(value || ""),
		required: true,
		textContentType: "password",
		title: "Password",
		errorText: loginFailed ? "Incorrect email or password. Use the link below to reset your password" : ""
	}), /* @__PURE__ */ React.createElement(Form.Button, {
		variant: "primary",
		size: "medium",
		analyticsName: `${analyticsPrefix}-submit`,
		label: "Confirm",
		"aria-label": "Confirm and submit password",
		loading,
		disabled: loading || password.length === 0
	})))), renderAdditionalAuth?.({
		verifyLogin,
		onSuccess,
		onFailure: reportLoginFailure
	}), /* @__PURE__ */ React.createElement(Col, { alignItems: "center" }, /* @__PURE__ */ React.createElement(Link, {
		variant: "primary",
		size: "medium",
		href: resetPasswordHref,
		target: "_blank",
		rel: "noopener noreferrer",
		analyticsName: `${analyticsPrefix}-forgot-password`,
		"aria-label": "Opens the forgot password page",
		onPress: () => {}
	}, "Forgot your password?")));
};
//#endregion
export { ReauthForm };

